import React, { Component } from "react";
import {
  ImgAuditoriaComunidades,
  ImgAuditoriaComunidades2,
} from "../../images/servicios";
import { ModernServicePage } from "../modern";

export class Auditoria extends Component {
  render() {
    const serviceData = {
      title: "Auditoría de Comunidades",
      subtitle:
        "Auditorías presenciales y remotas optimizadas para su comunidad",
      description:
        "Ofrecemos auditorías tanto presenciales como remotas, manteniendo la misma calidad y validez. Adaptamos el método según sus necesidades para optimizar tiempos y costos, garantizando transparencia y cumplimiento legal.",
      whatsappMessage:
        "Hola, necesito información sobre auditoría remota para comunidades (o presencial si es necesario)",
      features: [
        {
          emoji: "🌐",
          title: "Remota y Presencial",
          description:
            "Remota y Presencial — Auditores disponibles online sin perder validez; opción presencial cuando se requiera para evidencia física.",
        },
        {
          emoji: "🔍",
          title: "Verificación",
          description:
            "Verificar la buena administración de fondos, recomendaciones y obligaciones ante el cumplimiento de normativas legales vigentes de la Ley de copropiedades.",
        },
        {
          emoji: "💰",
          title: "Análisis Financiero",
          description:
            "Revisar de manera minuciosa los ingresos y egresos, con sus respaldos y documentos legales correspondientes; factura, Boleta de Compraventa.",
        },
        {
          emoji: "🏦",
          title: "Análisis Bancario",
          description:
            "Que permita conciliar los cargos bancarios con los documentos de egreso correspondientes y análisis del real estado de pago de los servicios básicos.",
        },
        {
          emoji: "📊",
          title: "Área Tributaria",
          description:
            "Dentro de este punto se abarca el pago de retenciones, impuestos únicos, (más declaración juradas correspondiente) y la declaración anual de la renta.",
        },
        {
          emoji: "👥",
          title: "Leyes Laborales",
          description:
            "Todo lo que considera la obligación del condominio para sus trabajadores como; contratos, liquidaciones de sueldos, cotizaciones previsionales, feriados, horas extras y finiquitos.",
        },
        {
          emoji: "📋",
          title: "Transparencia",
          description:
            "Se emite un informe especificando detalladamente el trabajo realizado, que servirá para dar claridad a la comunidad de qué decisiones tomar.",
        },
      ],
      images: [
        {
          src: ImgAuditoriaComunidades,
          alt: "Auditoría de Comunidades Profesional",
        },
        {
          src: ImgAuditoriaComunidades2,
          alt: "Administración de Condominios",
        },
      ],
      benefits: [
        "Optimización del tiempo: menos reuniones presenciales y coordinación más ágil",
        "Reducción de costos: disminuye traslados, viáticos y logística",
        "Mayor rapidez de ejecución: acorta tiempos de planificación y entrega",
        "Mejor uso de recursos: libera al equipo para actividades de mayor valor",
        "Misma validez y evidencia digital segura",
        "Experiencia especializada en condominios",
        "Cumplimiento de Ley de Copropiedad",
        "Informes detallados y transparentes",
        "Análisis integral de administración",
        "Verificación de documentación legal",
        "Recomendaciones de mejora",
        "Asesoría post-auditoría",
        "Disponibilidad presencial y remota",
      ],
      navigationItems: [
        { id: "modalidad", label: "Modalidad" },
        { id: "feature-0", label: "Verificación" },
        { id: "feature-1", label: "Finanzas" },
        { id: "feature-2", label: "Bancario" },
        { id: "feature-3", label: "Tributario" },
      ],
    };

    return <ModernServicePage {...serviceData} />;
  }
}

export default Auditoria;
